import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { ModalController, ToastController } from "@ionic/angular";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MasterService } from "src/app/services/master.service";
import { CorrigendumRequestModel } from "src/app/model/CorrigendumRequestModel";
import { CorrigendumUploadModel } from "src/app/model/CorrigendumUploadModel";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TenementExchangeOtpModel } from "src/app/model/TenementExchangeOtpModel";
import { LoginService } from "src/app/services/login.service";
import { InvoiceStageModel } from "src/app/model/InvoiceStageModel";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { LoaderComponent } from "../../loader/loader.component";
import { DatePipe } from "@angular/common";


@Component({
  selector: "app-modal",
  templateUrl: "./invoice-modal.html",
  styleUrls: ["./invoice-modal.scss"],
})
export class InvoiceModal implements OnInit {
  key: number;
  base64File: string;
  public uploadedDocument: string;
  public uploadedDocumentTimestamp: Date;
  public isFileUploaded: boolean = false;
  form: FormGroup = new FormGroup({});
  selectedFile: File;
  corrigendumName: string = "";
  isLoading = false;
  pageMode: string;
  corrigendumBase64: string;
  isOtpVerify: boolean = false;
  pageHead: string = "Login";
  maskMobileNumber: string;
  nonEditable: boolean = false;
  maskMobileNumberForFirstAppli: string;
  maskMobileNumberForSecondAppli: string;
  luser: TenementExchangeOtpModel = new TenementExchangeOtpModel();
  page: Page<InvoiceStageModel>;
  isSearchDisabled: boolean = false;
  dataSource: MatTableDataSource<InvoiceStageModel> = new MatTableDataSource();
  progressSpinnerDialog: any = null;
  counter: number = 0;
  receiptCounter: number = 0;
  invoiceDetails: InvoiceStageModel;
  submitDisabled: boolean=true;
  elementCount: number = 0;
  finalInvoiceDate:string;
  
  filterForm: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  isResendOtpButtonVisible: boolean = false;
  resendOtpIn: any = null;
  timerOn = true;

  displayedColumns: string[] = [
    "key",
   "stage",
   "count"

  ];
  @Output() dataModal = new EventEmitter<string>();

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private masterService: MasterService,
    private dialog: MatDialog,
    // public dialogRef: MatDialogRef<ModalComponent>,
    private router: Router,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe, 
  ) {
    this.filterForm = this.formBuilder.group({
      invoiceNumber: ['', Validators.required],
      invoiceDate: new FormControl(null, Validators.required),
  });
}


  ngOnInit() {
    // this.filterForm = this.formBuilder.group({
    //   invoiceNo: ['', Validators.required],
    // });
    this.isSubmitDisabled = false;
    this.masterService
      .countByStages()
      .subscribe(
        async (data: any) => {
          this.isLoading = false;
          this.page=data;
          this.dataSource = new MatTableDataSource(data);
          this.submitDisabled = data.length === 0;
          console.log("this.this.page?.content",data);
          // this.dataSource = new MatTableDataSource(this.page.content);
       
        },

        (error) => {
          this.isLoading = false;
          this.masterService.errorToast(
            error?.error?.errorMessage || error?.error?.message
          );
        }
      );

      this.filterForm = new FormGroup({
        invoiceNo: new FormControl(null, [Validators.required]),
        invoiceDate:new FormControl(null, [Validators.required]),
      });
  }

  cancel() {
    this.modalCtrl.dismiss(null, "cancel");
  }

  // calculateCount() {
  //   this.elementCount = this.dataSource.reduce((total, current) => total + current.count, 0);
  // }

  resetFilter() {
    // window.location.reload();
    this.modalCtrl.dismiss(null, "cancel");
  }


  back() {
    this.isOtpVerify = false;
    this.pageHead = "Login";
  }

  onSubmit() {
    // this.filterForm.markAllAsTouched();
    console.log("invoiceDate+++++++++++++++++++",this.filterForm.value.invoiceDate);
    this.finalInvoiceDate = this.datePipe.transform(this.filterForm.value.invoiceDate, "dd-MM-yyyy");
    console.log("finalInvoiceDate+++++++++++++++++++",this.finalInvoiceDate);

    this.isSearchDisabled = true;
    if (this.filterForm.valid) {
      const invoiceNo = this.filterForm.get('invoiceNo').value;
      console.log('Invoice number:', invoiceNo);

      if (!invoiceNo || invoiceNo.trim() === '') {
        alert('Please enter the invoice number.');
        return; 
      }

      this.showLoader();
      
      this.masterService.sendInvoiceNumber(invoiceNo,this.finalInvoiceDate).subscribe(
        (response) => {
          console.log('API response:', response);
          this.successToast("Invoice Raised successfully");
          this.modalCtrl.dismiss("submit")
          this.fetchInvoice(invoiceNo);
        },
        (error) => {
          console.error('API error:', error);
          this.errorToast("Duplicate Invoice Number. Please enter a different invoice number.");
          this.hideLoader();
        }
      );
    }
    else{
      this.errorToast("Invoice Number is Required");

    }
  }


  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

  fetchInvoice(invoiceNo: string)  {

    console.log(invoiceNo);

    this.masterService.fetchInvoiceReceipt(invoiceNo, this.finalInvoiceDate)
    .subscribe((data) => {
      this.hideLoader();
      if(data.status === 'SUCCESS') {
        console.log(data);
        this.downloadFile(data.base64File, data.fileName);
      }
      else {
        this.errorToast(data.errorMessage);  
      }
    }, error => {
      this.hideLoader();
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });

  }

  getCurrentDate(): string {
    const currentDate = new Date();
    return this.datePipe.transform(currentDate, 'yyyy-MM-dd') || ''; // Format the date as needed
  }

  showLoader() {
    this.isLoading = true;
  }


  hideLoader() {
    this.isLoading = false;
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }


}
